module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-squares"
  }, _vm._l((_vm.items), function(item) {
    return _c('span', {
      staticClass: "checkbox",
      class: {
        checked: _vm.value === item
      },
      on: {
        "click": function($event) {
          _vm.change(item)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-63a8c42d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63a8c42d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/radio-square.vue
// module id = 762
// module chunks = 0